const SettingsRecording = () => <>hello world!</>;

export default SettingsRecording;
